import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

export const RestoreAllTicketValidationSchema = z.object({
  spaceColumnId: z.string({ message: 'Space Column ID is required' }).min(1),
});
export type TRestoreAllTicketValidation = z.infer<typeof RestoreAllTicketValidationSchema>;
export type TRestoreAllTicketPayload = TRestoreAllTicketValidation;
export type TRestoreAllTicketResponse = ApiResponse<{
  message: string;
}>;

export const restoreAllTicket = async (payload: TRestoreAllTicketPayload): Promise<TRestoreAllTicketResponse> => {
  const url = `/ticket/restore-column/${payload.spaceColumnId}`;

  return axiosInstance.patch(url);
};

/**
 * Use Restore All Ticket React-Query Hook
 */
type UseRestoreAllTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof restoreAllTicket, AxiosErrorCustom>;
};

/**
 * Use Restore Ticket React-Query Hook
 */
export const useRestoreAllTicketMutation = ({ mutationConfig }: UseRestoreAllTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: restoreAllTicket,
    ...restConfig,
  });
};
